import { render, staticRenderFns } from "./FirmSpecificDocumentDetail.vue?vue&type=template&id=759f48b2"
import script from "./FirmSpecificDocumentDetail.vue?vue&type=script&lang=js"
export * from "./FirmSpecificDocumentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports